import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Grid from "@mui/system/Unstable_Grid/Grid";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import BeastNavbar from "../components/BeastNavbar.jsx";

import { serviceApi } from "../service";

import ReactionTable from "../components/ReactionTable";
import SearchBar from "../components/SearchBar";
import ReactionSearchCriteria from "../components/ReactionSearchCriteria";
import ColumnFilter from "../components/ColumnFilter";
import "../main.scss";
import "bootstrap/dist/css/bootstrap.min.css";

import projectLogo from "../beast-logo.png";

const ReactionTablePage = () => {
  const [data, setData] = useState([]);
  const [queryParameters, setQueryParameters] = useState({
    query: "reaction",
  }); // TODO
  const [searchConfig, setSearchConfig] = useState(null);
  const [filteredColumns, setFilteredColumns] = useState(null);
  const [allColumns, setAllColumns] = useState(null);
  const [columnUnits, setColumnUnits] = useState(null);

  useEffect(() => {
    serviceApi
      .queries()
      .then((data) => {
        // Set the searchConfig state from the API response
        setSearchConfig(data.queryParams);
      })
      .catch((error) => {
        console.error("Error fetching search config:", error);
      });

    serviceApi
      .reactionColumns()
      .then((data) => {
        // Set the filteredColumns state from the API response
        setAllColumns(data.all);
        setFilteredColumns(data.default);
        setColumnUnits(data.units);
      })
      .catch((error) => {
        console.error("Error fetching columns:", error);
      });
  }, []); // Fetch the initial configs only once on component mount

  useEffect(() => {
    if (
      queryParameters !== null &&
      filteredColumns !== null &&
      Object.keys(queryParameters).length > 1
    ) {
      serviceApi
        .queryAndFlatten(filteredColumns, queryParameters, "system_name") // TODO
        .then((data) => {
          //console.log('App', data);
          setData(data.result);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [queryParameters, searchConfig, filteredColumns]);

  // const handleColumnFilter = (selectedColumns) => {
  //   setFilteredColumns(selectedColumns);
  // };

  const theme = useTheme();

  return (
    <div>
      <BeastNavbar selected="reaction"/>
      <div className="wrapper">
      <Container>
        <div className="App">
          <h2
            style={{
              textAlign: "left",
              paddingTop: "25px",
              paddingBottom: "5px",
              paddingLeft: "20px",
            }}
          >
            BEAST Database Reactions
          </h2>
          <hr></hr>
          {searchConfig ? ( // Render SearchBar and DataTable only if searchConfig is available
            <>
              {/* <SearchBar
            onSearch={setQueryParameters}
            searchConfig={searchConfig}
            /> */}
              <ReactionSearchCriteria
                searchColumns={allColumns}
                onSearch={setQueryParameters}
                searchConfig={searchConfig}
                data={data}
              />
              <ColumnFilter
                columns={allColumns}
                defaultColumns={filteredColumns}
                onFilter={setFilteredColumns}
              />
              <ReactionTable data={data} units={columnUnits} />
            </>
          ) : (
            <p>Loading configuration...</p>
          )}
        </div>
        <div
          style={{
            textAlign: "left",
            paddingTop: "25px",
          }}
        ></div>
      </Container>
      </div>
    </div>
  );
};

export default ReactionTablePage;
